import React from 'react';
import TaskListView from '../../components/common/TaskListView';

/**
 * My Tasks shows the same unified task list as Monitoring > Tasks and
 * Inspections - the backend already scopes non-manager/admin users to only
 * their own assignments (via GET /monitoring/tasks), so this page is simply
 * that same view with My Tasks framing.
 */
const MyTasks = () => (
  <TaskListView
    title="My Tasks"
    subtitle="Inspection and monitoring tasks assigned to you"
  />
);

export default MyTasks;
